import { render, staticRenderFns } from "./organization-risk-decision-view.vue?vue&type=template&id=456ea012&scoped=true&"
import script from "./organization-risk-decision-view.vue?vue&type=script&lang=js&"
export * from "./organization-risk-decision-view.vue?vue&type=script&lang=js&"
import style0 from "./organization-risk-decision-view.vue?vue&type=style&index=0&id=456ea012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456ea012",
  null
  
)

export default component.exports